import { render, staticRenderFns } from "./AvulsoTabList.vue?vue&type=template&id=0bd64fa4&scoped=true"
import script from "./AvulsoTabList.vue?vue&type=script&lang=js"
export * from "./AvulsoTabList.vue?vue&type=script&lang=js"
import style0 from "./AvulsoTabList.vue?vue&type=style&index=0&id=0bd64fa4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd64fa4",
  null
  
)

export default component.exports